import { api } from '@/utils/api';

// Both sequence surfaces (the authored editor graph AND the full journey graph) show where enrolled
// people currently sit. Poll on this interval so those avatar piles / counts stay live as contacts
// advance through the walk — arms move on the order of the sweep cadence, so a few seconds is ample.
export const SEQUENCE_LIVE_POLL_MS = 5_000;

// Shared polling options for every sequence live query (faces + a contact's journey), so the surfaces
// can't drift on the interval OR the background behaviour. `refetchIntervalInBackground: false` keeps the
// poll paused unless the tab is focused; combined with React Query's structural sharing (unchanged
// payloads keep the same `data` reference, and both surfaces only read tracked `data`/`isPending`), an
// idle-but-focused sequence re-fetches cheaply without re-rendering the graph.
export const SEQUENCE_LIVE_POLL_OPTS = {
  refetchInterval: SEQUENCE_LIVE_POLL_MS,
  refetchIntervalInBackground: false,
};

/**
 * The per-node "who is here right now" query, shared by the sequence editor and the full journey graph
 * so both surfaces live-update on the exact same cadence. Keeping the polling config in one place means
 * the two views can never drift. `enabled` off (the per-contact locked graph) skips the team-wide poll —
 * a single-contact view shows its own progress from `stepStatus`, not the team's avatar piles.
 */
export function useSequenceFaces(teamId: string, sequenceId: string, enabled = true) {
  return api.sequence.faces.useQuery({ teamId, sequenceId }, { ...SEQUENCE_LIVE_POLL_OPTS, enabled });
}
